module.exports = __webpack_public_path__ + "static/media/nav_left_transform.8e2b5237.svg";